import React, { useState } from 'react';
import Icon from './Icon.js';
import { Colors as C } from '../../constants/Colors.js';

const AUTH_INPUT_FOCUS = (e) => {
  e.target.style.borderColor = C.gold;
};
const AUTH_INPUT_BLUR = (e) => {
  e.target.style.borderColor = 'rgba(0,0,0,0.17)';
};

const DARK_INPUT_FOCUS = (e) => {
  e.target.style.borderColor = C.gold;
};
const DARK_INPUT_BLUR = (e) => {
  e.target.style.borderColor = 'rgba(255,255,255,0.12)';
};

/**
 * Campo contraseña con botón mostrar/ocultar (icono ojo).
 * @param {'auth'|'dark'} variant — auth: modal login (fondo claro); dark: Ajustes
 */
export default function PasswordInput({
  value,
  onChange,
  placeholder,
  className = 'dv-input',
  style = {},
  autoComplete,
  variant = 'auth',
  onFocus,
  onBlur,
  disabled,
  id,
}) {
  const [visible, setVisible] = useState(false);

  const isAuth = variant === 'auth';
  const baseStyle = isAuth
    ? {
        width: '100%',
        padding: '11px 40px 11px 13px',
        border: '1px solid rgba(0,0,0,0.17)',
        borderRadius: 7,
        fontSize: '0.88rem',
        outline: 'none',
        background: '#fafafa',
        transition: 'border-color .18s',
        fontFamily: 'inherit',
        color: '#1a1a1a',
      }
    : {
        width: '100%',
        padding: '10px 40px 10px 12px',
        borderRadius: 10,
        border: '0.5px solid rgba(255,255,255,0.12)',
        background: 'rgba(255,255,255,0.06)',
        color: '#fff',
        fontSize: 13,
        outline: 'none',
        fontFamily: 'inherit',
      };

  const iconColor = isAuth ? 'rgba(0,0,0,0.45)' : 'rgba(255,255,255,0.45)';

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        id={id}
        className={className}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        style={{ ...baseStyle, ...style }}
        onFocus={(e) => {
          if (isAuth) AUTH_INPUT_FOCUS(e);
          else DARK_INPUT_FOCUS(e);
          onFocus?.(e);
        }}
        onBlur={(e) => {
          if (isAuth) AUTH_INPUT_BLUR(e);
          else DARK_INPUT_BLUR(e);
          onBlur?.(e);
        }}
      />
      <button
        type="button"
        tabIndex={-1}
        aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        disabled={disabled}
        onClick={() => setVisible(v => !v)}
        style={{
          position: 'absolute',
          right: 8,
          top: '50%',
          transform: 'translateY(-50%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          padding: 0,
          border: 'none',
          background: 'transparent',
          cursor: disabled ? 'not-allowed' : 'pointer',
          borderRadius: 6,
          opacity: disabled ? 0.5 : 1,
        }}
      >
        <Icon name={visible ? 'eyeOff' : 'eye'} size={18} color={iconColor} />
      </button>
    </div>
  );
}
